import { render, staticRenderFns } from "./PaymentSuccessPackage.vue?vue&type=template&id=5fbf0466&scoped=true"
import script from "./PaymentSuccessPackage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessPackage.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessPackage.vue?vue&type=style&index=0&id=5fbf0466&prod&lang=scss"
import style1 from "./PaymentSuccessPackage.vue?vue&type=style&index=1&id=5fbf0466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf0466",
  null
  
)

export default component.exports